import { useStaticQuery, graphql } from "gatsby"

const usePostsQuery = () => {
  return useStaticQuery(graphql`
    query PostsQuery {
      posts: allWpPost(sort: {date: DESC}) {
        nodes {
          title
          slug
          categories {
            nodes {
              slug
              name
            }
          }
          acf {
            author {
              ... on WpTeamMember {
                id
              }
            }
          }
          featuredImage {
            node {
              sourceUrl
              altText
            }
          }
        }
      }
    }
  `)
}

export default usePostsQuery